import { render, staticRenderFns } from "./FormInputCheckboxes.vue?vue&type=template&id=6ad80bfc&"
import script from "./FormInputCheckboxes.vue?vue&type=script&lang=js&"
export * from "./FormInputCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad80bfc')) {
      api.createRecord('6ad80bfc', component.options)
    } else {
      api.reload('6ad80bfc', component.options)
    }
    module.hot.accept("./FormInputCheckboxes.vue?vue&type=template&id=6ad80bfc&", function () {
      api.rerender('6ad80bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputCheckboxes.vue"
export default component.exports